import React, { useState, useEffect } from "react";
import refreshLogo from "../img/refreshLogo.svg";
import Expand_down from "../img/Expand_down.svg";
import Add_round from "../img/Add_round.svg";
import Add_roundWhite from "../img/Add_roundWhite.svg";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance";
import { div } from "motion/react-client";
import { motion, AnimatePresence } from "framer-motion";
import HeaderAddApp from "./HeaderAddApp";

const EditAddOnDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { addonId, id } = location.state || {};

  const [addonName, setAddonName] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [fileName, setFileName] = useState("No file chosen");
  const [haveLimit, setHaveLimit] = useState(true);
  const [limit, setLimit] = useState("");
  const [features, setFeatures] = useState([
    { id: null, statement: "", is_active: true },
  ]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [durations, setDurations] = useState([
    {
      id: null,
      duration_master_id: "",
      price: "",
      dropdownOpen: false,
      duration_name: "",
      is_active: true,
    },
  ]);

  const [durationOptions, setDurationOptions] = useState([]);

  useEffect(() => {
    if (addonId) {
      fetchAddonDetails(addonId);
    }
  }, [addonId]);

  const fetchAddonDetails = async (id) => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get(`/admin-app/api/v1/read-addon/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status === "success") {
        const data = res.data.data;
        setAddonName(data.name || "");
        setDescription(data.description || "");
        setImageFile(data.image);
        setFileName(data.image ? "Uploaded Image" : "No file chosen");
        setHaveLimit(data.have_limit);
        setLimit(data.limit?.toString() || "");

        setFeatures(
          data.addon_features?.map((f) => ({
            id: f.id,
            statement: f.statement,
            is_active: true,
          })) || [{ id: null, statement: "", is_active: true }]
        );

        setDurations(
          data.durations?.map((d) => ({
            id: d.id,
            duration_master_id: d.duration_master_id,
            price: d.price.toString(),
            dropdownOpen: false,
            duration_name: d.duration_name,
            is_active: true,
          })) || [
            {
              id: null,
              duration_master_id: "",
              price: "",
              dropdownOpen: false,
              duration_name: "",
              is_active: true,
            },
          ]
        );
      }
    } catch (error) {
      console.error("Error fetching add-on details:", error);
    }
  };

  useEffect(() => {
    fetchDurations();
  }, []);

  const fetchDurations = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get("/admin-app/api/v1/list-duration", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status === "success") {
        setDurationOptions(res.data.data.results || []);
      }
    } catch (error) {
      console.error("Error fetching durations:", error);
    }
  };

  const toggleDropdown = (index) => {
    setDurations((prev) =>
      prev.map((d, i) => ({
        ...d,
        dropdownOpen: i === index ? !d.dropdownOpen : false, // Only toggle current
      }))
    );
  };

  const handleSelectDuration = (index, selectedId, selectedName) => {
    setDurations((prev) =>
      prev.map((d, i) =>
        i === index
          ? {
              ...d,
              duration_master_id: selectedId,
              duration_name: selectedName,
              dropdownOpen: false,
            }
          : d
      )
    );
  };
  const handleAddDuration = () => {
    setDurations((prev) => [
      ...prev,
      {
        id: null,
        duration_master_id: "",
        price: "",
        dropdownOpen: false,
        duration_name: "",
        is_active: true,
      },
    ]);
  };

  const handleAddFeature = () => {
    setFeatures((prev) => [
      ...prev,
      { id: null, statement: "", is_active: true },
    ]);
  };

  const uploadImageFile = async (file) => {
    try {
      const token = localStorage.getItem("accessToken");
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.post(
        "/admin-app/api/v1/upload-file",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "success") {
        return response.data.data.id; // Return the uploaded image ID
      } else {
        console.error("Image upload failed:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      return null;
    }
  };

  const validateForm = () => {
    let firstError = "";

    if (!addonName.trim()) {
      firstError = "Add-On Title is required.";
    } else if (!description.trim()) {
      firstError = "Description is required.";
    } else if (haveLimit && (!limit || isNaN(limit) || Number(limit) <= 0)) {
      firstError = "Valid Limit count is required.";
    } else {
      const activeDurations = durations.filter((d) => d.is_active !== false);
      for (let i = 0; i < activeDurations.length; i++) {
        const d = activeDurations[i];
        if (!d.duration_master_id) {
          firstError = `Duration ${i + 1} must be selected.`;
          break;
        }
        if (!d.price || isNaN(d.price) || Number(d.price) <= 0) {
          firstError = `Valid price for Duration ${i + 1} is required.`;
          break;
        }
      }
      if (!firstError) {
        const activeFeatures = features.filter((f) => f.is_active !== false);
        for (let i = 0; i < activeFeatures.length; i++) {
          if (!activeFeatures[i].statement.trim()) {
            firstError = `Feature ${i + 1} cannot be empty.`;
            break;
          }
        }
      }
    }

    if (firstError) {
      setApiMessage(firstError);
      setShowErrorModal(true);
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      const token = localStorage.getItem("accessToken");
      let uploadedImageId = null;

      // Upload image only if a new file was selected
      if (imageFile instanceof File) {
        uploadedImageId = await uploadImageFile(imageFile);
        if (!uploadedImageId) {
          alert("Image upload failed.");
          return;
        }
      } else if (imageFile && typeof imageFile === "number") {
        uploadedImageId = imageFile;
      }

      const feature_data = features.map((f) => ({
        id: f.id || null,
        is_active: f.is_active !== false,
        statement: f.statement || "",
      }));

      const duration_data = durations.map((d) => ({
        id: d.id || null,
        is_active: d.is_active !== false,
        duration_master_id: parseInt(d.duration_master_id),
        price: parseFloat(d.price),
      }));

      const payload = {
        project_id: id, // Replace if dynamic
        id: addonId,
        name: addonName,
        description,
        image: uploadedImageId,
        limit: haveLimit ? parseInt(limit) : null,
        duration_data,
        feature_data,
      };

      const res = await api.post("/admin-app/api/v1/edit-addon", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === "success") {
        setApiMessage(res.data.data);
        setShowSuccessModal(true);
      } else {
        setApiMessage(res.data.data);
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error saving add-on:", error);
      alert("An error occurred while saving.");
    }
  };

  const handleRemoveDuration = (index) => {
    setDurations((prev) =>
      prev.map((d, i) => (i === index ? { ...d, is_active: false } : d))
    );
  };

  return (
    <div>
      <HeaderAddApp></HeaderAddApp>

      <div className="m-8">
        <div className="flex justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] my-3 py-2 px-4 rounded">
          <span>Edit Add-On Details</span>
          {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
        </div>

        <div className="w-full flex flex-col gap-4 text-sm">
          <div className="flex flex-col ">
            {/* <div className="w-1/2 relative">
              <div
                className="pl-5 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter bg-right bg-no-repeat focus:outline-none appearance-none flex items-center justify-between cursor-pointer"
                style={{
                  backgroundImage: `url(${Expand_down})`,
                  backgroundPosition: "98% center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            </div> */}
            <label htmlFor="" className="text-sm font-semibold ">
              Add Title
            </label>
            <input
              type="text"
              className="sm:w-1/2 mt-1 pl-5 h-10 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none "
              placeholder="Add Title"
              value={addonName}
              onChange={(e) => setAddonName(e.target.value)}
            />
          </div>

          <div className="">
            <label htmlFor="" className="text-sm font-semibold ">
              Description
            </label>

            <textarea
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full mt-1 pl-5 pt-2 h-16 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none "
            ></textarea>
          </div>

          <div className="sm:w-1/2">
            <span className="text-sm font-semibold ">Application Icon</span>
            <div className="w-full px-1 mt-1 flex items-center gap-6  h-10 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none ">
              <input
                type="file"
                accept="image/*"
                className="hidden"
                id="iconUpload"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setFileName(file?.name || "No file chosen");
                  setImageFile(file); // You can handle upload on save
                }}
              />
              <label
                htmlFor="iconUpload"
                className="bg-primary rounded-md px-3 py-1 font-semibold text-white cursor-pointer hover:scale-105 transition-transform duration-300"
                style={{ willChange: "transform" }}
              >
                Choose File
              </label>

              <span className="text-[#9CA3AF]"></span>
            </div>
          </div>
          <div className="sm:w-1/2 flex gap-4">
            <div className="w-1/2 flex gap-6 items-center h-10">
              <span className="text-base font-semibold  ">
                Do you have limit ?
              </span>
              {/* Toggle Button */}
              <div
                className={`w-14 h-7 rounded-full flex items-center cursor-pointer px-1 transition-all duration-500 ease-in-out ${
                  haveLimit
                    ? "bg-primary justify-start"
                    : "bg-gray-200 justify-end"
                }`}
                onClick={() => setHaveLimit((prev) => !prev)}
                style={{ position: "relative" }}
              >
                <div
                  className="bg-white rounded-full w-5 h-5 transition-all duration-500 ease-in-out"
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    left: haveLimit ? "4px" : "calc(100% - 24px)",
                  }}
                ></div>
              </div>
            </div>

            {haveLimit && (
              <input
                type="number"
                className="w-1/2 pl-5 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                placeholder="Add limit count"
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
              />
            )}
          </div>

          <h2 className="text-lg font-semibold">Set Duration</h2>
          <div className="flex flex-col gap-4">
            {durations.map((d, index) =>
              d.is_active !== false ? (
                <div key={index} className="w-full flex gap-5">
                  {/* Dropdown and Price Input */}
                  <div className="w-1/2 relative">
                    <label htmlFor="" className="text-sm font-semibold ">
                      Select Duration
                    </label>
                    <div
                      onClick={() => toggleDropdown(index)}
                      className="pl-5 mt-1 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter flex items-center justify-between cursor-pointer"
                      style={{
                        backgroundImage: `url(${Expand_down})`,
                        backgroundPosition: "98% center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <span
                        className={
                          d.duration_master_id ? "text-black" : "text-[#9CA3AF]"
                        }
                      >
                        {d.duration_name || "Select Duration"}
                      </span>
                    </div>

                    {d.dropdownOpen && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto">
                        {durationOptions.length === 0 ? (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No durations
                          </div>
                        ) : (
                          durationOptions.map((option) => (
                            <div
                              key={option.id}
                              onClick={() =>
                                handleSelectDuration(
                                  index,
                                  option.id.toString(),
                                  option.name
                                )
                              }
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                            >
                              {option.name}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  <div className="w-1/2 flex flex-col">
                    <label htmlFor="" className="text-sm font-semibold ">
                      Platform Selling Price
                    </label>

                    <input
                      type="number"
                      className="flex mt-1 flex-grow pl-5 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                      placeholder="Platform Selling Price"
                      value={d.price}
                      onChange={(e) => {
                        const updated = [...durations];
                        updated[index].price = e.target.value;
                        setDurations(updated);
                      }}
                    />
                  </div>

                  <button
                    onClick={() => handleRemoveDuration(index)}
                    className="text-gray-400 font-bold"
                    title="Remove"
                  >
                    ✕
                  </button>
                </div>
              ) : null
            )}

            <div
              className="flex justify-between items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2 text-primary hover:text-white hover:bg-primary hover:scale-105 transition-transform duration-300 group"
              style={{ willChange: "transform" }}
              onClick={handleAddDuration}
            >
              <img
                src={Add_round}
                alt=""
                className="block group-hover:hidden"
              />
              <img
                src={Add_roundWhite}
                alt=""
                className="hidden group-hover:block"
              />
              <span className="">Add Duration</span>
            </div>
          </div>

          <h2 className="text-lg font-semibold">Add-on Feature</h2>
          <div className="flex flex-col gap-4">
            <div className="w-full grid grid-cols-2 sm:flex-row gap-5">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-2 items-center relative">
                  <input
                    type="text"
                    className="flex-1 pl-5 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                    placeholder="Feature"
                    value={feature.statement}
                    onChange={(e) => {
                      const updated = [...features];
                      updated[index].statement = e.target.value;
                      setFeatures(updated);
                    }}
                  />
                  {features.length > 1 && index > 0 && (
                    <button
                      onClick={() => {
                        setFeatures((prev) =>
                          prev.map((f, i) =>
                            i === index ? { ...f, is_active: false } : f
                          )
                        );
                      }}
                      className="text-gray-400 font-bold absolute right-3 "
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-4 sm:flex-row sm:w-1/2 justify-between">
              <div
                className="flex justify-between items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2 text-primary hover:bg-primary hover:text-white hover:scale-105 transition-transform duration-300 group"
                style={{ willChange: "transform" }}
                onClick={handleAddFeature}
              >
                <img
                  src={Add_round}
                  alt=""
                  className="block group-hover:hidden"
                />
                <img
                  src={Add_roundWhite}
                  alt=""
                  className="hidden group-hover:block"
                />
                <span className="">Add Feature</span>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-end gap-4 mt-14">
            <button
              className="border border-primary text-primary w-64 py-1 font-semibold rounded-md text-lg bg-transparent hover:scale-105 transition-transform duration-300"
              onClick={() => setShowCancelModal(true)}
              style={{ willChange: "transform" }}
            >
              Cancel
            </button>

            <button
              className="bg-primary w-64 py-1 text-white font-semibold rounded-md text-lg hover:scale-105 transition-transform duration-300"
              onClick={handleSave}
              style={{ willChange: "transform" }}
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {showSuccessModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-12 h-12 text-green-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Success!
                  </h3>
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate(-1);
                    }}
                    className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg"
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showErrorModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-8 h-8 text-red-500"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          d="M12 8v4m0 4h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => setShowErrorModal(false)}
                    className="w-full py-3 px-4 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg"
                  >
                    Try Again
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showCancelModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-yellow-50">
                    <motion.div
                      animate={{ scale: [1, 1.1, 1] }}
                      transition={{ repeat: Infinity, duration: 1 }}
                    >
                      <svg
                        className="w-12 h-12 text-yellow-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    Are you sure you want to cancel?
                  </h3>
                  <p className="text-gray-600 mb-6">
                    All unsaved changes will be lost.
                  </p>
                </div>
                <div className="px-6 pb-6 flex justify-between gap-4">
                  <button
                    onClick={() => setShowCancelModal(false)}
                    className="w-1/2 py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium rounded-lg"
                  >
                    Go Back
                  </button>
                  <button
                    onClick={() => {
                      setShowCancelModal(false);
                      // Redirect or reset logic here
                      window.history.back(); // Replace if you have a better route handler
                    }}
                    className="w-1/2 py-2 px-4 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg"
                  >
                    Confirm Cancel
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default EditAddOnDetails;
